import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicOrderContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canShippingAddressBeUpdated!: boolean;
}
